import { colors2 } from "oolib";
import { SIGNAL_CATEGORY_ACCENT, SIGNAL_CATEGORY_FILL } from "@/components/analysisModules/comps/SignalFilters/signalCategories";

/**
 * How each zone looks, in one place — the field's backgrounds (only fires
 * carries a tint; the dividers do the rest), the list's
 * chips and the rail's eyebrows all read from here. Zone hues borrow the
 * signal-category palette on purpose (fires read dissatisfaction-red,
 * resolving reads satisfaction-green), so nothing new has to be learned.
 * The words (label, hint) come with every response's `prioritiesCopy.zones`
 * — the tenant's overrides merged over the defaults on the server (okf-be
 * priorities/copy.js), so no reader keeps defaults of its own.
 */
const ZONES = {
  fires: {
    text: SIGNAL_CATEGORY_ACCENT.userDissatisfaction,
    fill: SIGNAL_CATEGORY_FILL.userDissatisfaction,
    onFill: colors2.white,
    field: "rgba(212,85,58,0.10)",
  },
  chronic: {
    text: SIGNAL_CATEGORY_ACCENT.userDissatisfaction,
    fill: SIGNAL_CATEGORY_FILL.userDissatisfaction,
    onFill: colors2.white,
    field: "transparent",
  },
  resolving: {
    text: SIGNAL_CATEGORY_ACCENT.userSatisfaction,
    fill: SIGNAL_CATEGORY_FILL.userSatisfaction,
    onFill: colors2.white,
    field: "transparent",
  },
  emerging: {
    text: SIGNAL_CATEGORY_ACCENT.userBehaviour,
    fill: SIGNAL_CATEGORY_FILL.userBehaviour,
    onFill: colors2.white,
    field: "transparent",
  },
  background: {
    text: colors2.grey60,
    fill: colors2.grey5,
    onFill: colors2.grey80,
    field: "transparent",
  },
  fading: {
    text: colors2.grey60,
    fill: colors2.grey5,
    onFill: colors2.grey80,
    field: "transparent",
  },
};

// A finding whose momentum could not be computed has no zone; it still
// needs a chip.
export const NO_ZONE = {
  label: "No momentum",
  hint: "Momentum could not be computed for this sub-topic.",
  text: colors2.grey50,
  fill: colors2.grey5,
  onFill: colors2.grey80,
};

// The wins column's wording.
const WIN_COPY = {
  label: "Win",
  risingEyebrow: "Bright spot",
  slippingEyebrow: "Slipping",
  emptyList: "No satisfaction sub-topics in this scope.",
};

// Colours from here, words from the response's `prioritiesCopy.zones`
// (already resolved against the defaults on the server). Colours are never
// overridden — a zone's hue means the same thing on every tenant. A reader
// without the copy yet gets the zone's key as its label.
export const resolveZones = (copy) =>
  Object.fromEntries(Object.entries(ZONES).map(([key, zone]) => [key, { label: key, hint: "", ...zone, ...(copy?.zones?.[key] || {}) }]));

export const resolveWinCopy = (copy) => ({ ...WIN_COPY, ...(copy?.win || {}) });
